export enum AtiraLinkBorderRadius {
  NONE = '0',
  SMALL = '4',
  MEDIUM = '8',
  LARGE = '16',
  CIRCLE = '99',
}
